'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DesktopMenu = exports.DESKTOP_MENU_INNER = exports.DESKTOP_MENU_SELECTOR = undefined;

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*
 *  Mobile Menu
 *    Scripts for the mobile menu
 *
 *  Version:
 *    1.0.0 - 2019/12/11
 */

var DESKTOP_MENU_SELECTOR = exports.DESKTOP_MENU_SELECTOR = '[data-desktop-menu]';
var DESKTOP_MENU_INNER = exports.DESKTOP_MENU_INNER = '[data-desktop-menu-inner]';
var DESKTOP_MENU_ITEM = '[data-desktop-menu-item]';
var DESKTOP_MENU_SUBMENU = '[data-desktop-submenu]';
var DESKTOP_SUBMENU_TOGGLE = '[data-desktop-submenu-toggle]';
var DESKTOP_SUBMENU_ITEM_SELECTOR = '[data-desktop-menu-link]';
var DESKTOP_SUBMENU_ITEM_SUBLINK = '[data-desktop-menu-sublink]';
var DESKTOP_SUBMENU_CONTENT = '[data-desktop-menu-submenu-content]';
var DESKTOP_SUBSUBSUBMENU_LINK = '[data-desktop-menu-subsubsubmenu-link]';
var DESKTOP_SUBSUBSUBMENU_CONTENT = '[data-desktop-menu-subsubsubmenu-content]';
var DESKTOP_SUBMENU_PROMO_CONTENT = '[data-desktop-menu-submenu-promo]';

var DESKTOP_SEARCH_TOGGLE = '[data-desktop-menu-search-toggle]';
var DESKTOP_SEARCH = '[data-desktop-menu-search]';

//Attrs
var DESKTOP_MENU_HANDLE = 'data-desktop-menu-link-handle';

//Classes
var CLASS_VISIBLE = 'is-visible';
var CLASS_ACTIVE = 'is-active';
var CLASS_OPEN = 'is-open';
var CLASS_MENU_OPEN = 'is-menu-open';

var DesktopMenu = exports.DesktopMenu = function () {
  function DesktopMenu(container) {
    var _this = this;

    (0, _classCallCheck3.default)(this, DesktopMenu);

    this.container = container;

    //Elements
    this.menuInner = container.find(DESKTOP_MENU_INNER);
    this.submenuLink = container.find(DESKTOP_SUBMENU_ITEM_SELECTOR);
    this.submenuContent = container.find(DESKTOP_SUBMENU_CONTENT);
    this.subsubsubmenuLink = container.find(DESKTOP_SUBSUBSUBMENU_LINK);
    this.subsubsubmenuContent = container.find(DESKTOP_SUBSUBSUBMENU_CONTENT);
    this.submenuPromoContent = container.find(DESKTOP_SUBMENU_PROMO_CONTENT);

    this.desktopSearch = container.find(DESKTOP_SEARCH);

    container.on('mouseenter', DESKTOP_SUBMENU_ITEM_SELECTOR, function (e) {
      return _this.onHoverSubLink(e);
    });
    container.on('mouseleave', DESKTOP_MENU_INNER, function () {
      return _this.onMenuExit();
    });
    container.on('click touchend', DESKTOP_SEARCH_TOGGLE, function (e) {
      return _this.onSearchToggleClicked(e);
    });
    container.on('mouseenter', '[data-desktop-menu-subsubsubmenu-link]', function (e) {
      return _this.onHoverSubSubSubLink(e);
    });
  }

  (0, _createClass3.default)(DesktopMenu, [{
    key: 'onSubmenuToggle',
    value: function onSubmenuToggle(e) {
      e.preventDefault(), e.stopPropagation();

      var self = $(e.currentTarget);
      var submenuContainer = self.closest(DESKTOP_MENU_ITEM);

      //If this one is open, close
      if (submenuContainer.hasClass(CLASS_MENU_OPEN)) {
        submenuContainer.removeClass(CLASS_MENU_OPEN);
        return;
      }

      //Close all submenus and show the new one
      this.menuItem.removeClass(CLASS_MENU_OPEN);
      submenuContainer.addClass(CLASS_MENU_OPEN);
    }
  }, {
    key: 'onHoverSubLink',
    value: function onHoverSubLink(e) {
      var self = $(e.currentTarget);
      var handle = self.attr(DESKTOP_MENU_HANDLE);
      var group = self.attr('data-group');

      //Find if there is content for this menu
      var content = this.container.find(DESKTOP_SUBMENU_CONTENT + '[' + DESKTOP_MENU_HANDLE + '=\'' + handle + '\']');
      if (!content.length) return;

      //Update our classes
      this.submenuLink.each(function (_, el) {
        if ($(el).attr('data-group') != group) return;
        $(el).removeClass(CLASS_ACTIVE);
      });
      this.submenuContent.each(function (_, el) {
        if ($(el).attr('data-group') != group) return;
        $(el).removeClass(CLASS_VISIBLE);;
      });
      self.addClass(CLASS_ACTIVE);
      content.addClass(CLASS_VISIBLE);
    }
  }, {
    key: 'onMenuExit',
    value: function onMenuExit() {
      this.submenuPromoContent.addClass(CLASS_VISIBLE);
    }
  }, {
    key: 'onSearchToggleClicked',
    value: function onSearchToggleClicked(e) {
      var _this2 = this;

      e.preventDefault(), e.stopPropagation();

      if (this.desktopSearch.hasClass('is-visible')) {
        this.desktopSearch.removeClass('is-visible');
        setTimeout(function () {
          return _this2.menuInner.removeClass('is-search-view');
        }, 200);
        return;
      }

      this.desktopSearch.addClass('is-visible');
      this.menuInner.addClass('is-search-view');
    }
  }, {
    key: 'onHoverSubSubSubLink',
    value: function onHoverSubSubSubLink(e) {
      var self = $(e.currentTarget);
      var handle = self.attr(DESKTOP_MENU_HANDLE);
      var group = self.attr('data-group');

      //Find if there is content for this menu
      var content = this.container.find(DESKTOP_SUBSUBSUBMENU_CONTENT + '[' + DESKTOP_MENU_HANDLE + '=\'' + handle + '\']');
      if (!content.length) return;

      //Update our classes
      this.subsubsubmenuLink.removeClass(CLASS_ACTIVE);
      this.subsubsubmenuContent.removeClass(CLASS_VISIBLE);
      self.addClass(CLASS_ACTIVE);
      content.addClass(CLASS_VISIBLE);
    }
  }]);
  return DesktopMenu;
}();